<template>
  <cec-select-search
    v-model="internalValue"
    :options="options"
    :state="estadoComponente"
    :disabled="desabilitarInput || loading"
    :placeholder="placeholder"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import axios from 'axios'
import CecSelectSearch from '@/views/componentes/dropdown/CecSelectSearch.vue'

export default {
  name: 'ProducaoFormulaProdutoDropDown',
  components: { CecSelectSearch },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    modo: {
      type: String,
      default: 'produto-final'
    },
    label: String,
    place: String,
    labelBotao: {
      type: String,
      default: ''
    },
    idInicial: {
      type: [String, Number, null],
      default: null
    },
    classeRequired: Boolean,
    desabilitarInput: Boolean,
    state: {
      type: [Boolean, null],
      default: null
    },
    inputClass: {
      type: [String, Object, Array],
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.value != null ? this.value : this.idInicial,
      options: [],
      loading: false
    }
  },
  computed: {
    basePath() {
      return `/api/protected/producao-formula/${this.modo}`
    },
    placeholder() {
      return this.place || (this.modo === 'materia-prima'
        ? 'Pesquise a matéria-prima pelo nome ou codigo...'
        : 'Pesquise o produto final pelo nome ou codigo...')
    },
    estadoComponente() {
      if (this.state !== null) return this.state
      if (this.classeRequired && !this.internalValue) return false
      return null
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
    idInicial(newVal) {
      if (this.value == null) {
        this.internalValue = newVal
      }
      this.fetchRegistros()
    },
    modo() {
      this.internalValue = this.value != null ? this.value : this.idInicial
      this.fetchRegistros()
    },
    internalValue(newVal) {
      const selecionado = this.options.find(option => option.value === newVal)
      this.$emit('input', newVal)
      this.$emit('change', newVal)
      this.$emit('retornaId', newVal)
      this.$emit('retornaNome', selecionado ? selecionado.text : null)
      this.$emit('retornaCusto', selecionado ? (selecionado.custo || 0) : 0)
    }
  },
  created() {
    this.fetchRegistros()
  },
  methods: {
    async fetchRegistros() {
      this.loading = true
      try {
        const { data } = await axios.get(`${this.basePath}/localizar`)
        const registros = data || []
        this.options = registros.map(item => ({
          value: item.ID,
          text: item.CODIGONOME || item.NOME_COMPLETE || `${item.ID} - ${item.NOME}`,
          custo: item.VL_CUSTO || 0
        }))

        if (this.internalValue != null) {
          const existe = this.options.some(option => option.value === this.internalValue)
          if (!existe) {
            this.internalValue = null
          }
        }
      } catch (error) {
        this.options = []
        console.error('Erro ao buscar produtos da fórmula', error)
      } finally {
        this.loading = false
      }
    },
    limpar() {
      this.internalValue = null
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/producao/producao-formula/ProducaoFormulaProdutoDropDown.vue